import { Reaction } from '@ms/yammer-graphql';

import { Message } from '../../state/types';

export const getId = (messageId: Message['id'], reaction: Reaction | null) =>
  `${messageId}-${reaction ?? 'ALL_REACTIONS'}`;
